<template>
    <section class="auth-page hero is-fullheight" :style="{ backgroundImage: `url('/images/bg_auth.png')` }">
        <div class="auth-page-fixed">
            <div class="lang">
                <b-icon icon="web" size="is-small" />
                <a href="#" @click.prevent="toggleLocale">
                    {{ locale === 'en' ? 'Français' : 'English' }}
                </a>
            </div>
        </div>

        <div class="hero-body is-justify-content-center is-align-items-center">
            <div class="auth-card">
                <div class="auth-card-header has-text-centered">
                    <figure class="image is-inline-block" style="max-width: 160px">
                        <img :src="brandingLogo || '/images/logo.svg'" alt="logo" />
                    </figure>
                </div>

                <div class="auth-card-body">
                    <router-view v-slot="{ Component }">
                        <transition name="auth-fade" mode="out-in" :duration="{ leave: 0, enter: 200 }">
                            <component :is="Component" :key="$route.path" />
                        </transition>
                    </router-view>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useTheme } from '@/composables/useTheme';

export default {
    data() {
        return {
            brandingLogo: window.config?.orgBranding?.logo || null,
            locale: window.config?.locale || 'en'
        };
    },

    mounted() {
        document.title = i18n.t('Login') + ` | ${AppTitle}`;

        // Apply royal theme by default on login page (unless org branding overrides)
        const { applyTheme } = useTheme();
        const orgTheme = window.config?.orgBranding?.theme_preset;
        applyTheme(orgTheme || 'royal');
    },

    methods: {
        toggleLocale() {
            this.locale = this.locale === 'en' ? 'fr' : 'en';
            i18n.locale.value = this.locale;
            window.config.locale = this.locale;
            document.title = i18n.t('Login') + ` | ${AppTitle}`;
        }
    }
};
</script>
